import { BaseEntity } from '../../models';
import { grupoClassificacaoSituacaoAtivo } from './situacao/grupo-classificacao-situacao';
import { GrupoClassificacaoClassificacao } from './classificacao';

export class GrupoClassificacao implements BaseEntity {
    readonly id: number;
    idEmpresa: number;
    codigo: number;
    nome: string;
    situacao: number;
    classificacoesSlug: number[];
    classificacoesNome: string;
    classificacoes: GrupoClassificacaoClassificacao[];

    // Controles de Lançamentos do Grupo de Classificação
    /** Se a meta é controlada por quantidade */
    controleQuantidade: boolean;
    /** Se a meta é controlada por peso */
    controlePeso: boolean;
    /** Se a meta é controlada por valor */
    controleValor: boolean;
    /** Lançamento base utilizada na meta */
    lancamento: number;
    /** Se deve solicitar o preço médio nas análises de mercados lançadas através da meta quando o lançamento for por Quantidade ou Peso */
    solicitarPrecoMedio: boolean;


    // Configurações
    considerarClienteAnaliseMercado: boolean;
    considerarMeta: boolean;

    /** Se pode excluir o grupo de classificação */
    canDelete: boolean;

    constructor() {
        this.situacao = grupoClassificacaoSituacaoAtivo.id;
        this.classificacoes = [];
    }
}
